"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sensePageFacetFromDocument = exports.senseDocumentMutation = void 0;
const Common_1 = require("../Common");
const Logger_1 = __importDefault(require("../Logger"));
const Utils_1 = require("../Utils");
function print(...args) {
    Logger_1.default.debug("[MutationSensor]", ...args);
}
function senseDocumentMutation(onSensed) {
    print("Waiting for general readiness");
    const promisedCallback = (0, Utils_1.waitForDocumentReady)().then(() => {
        print("Started");
        const bodyObserver = new MutationObserver(() => {
            onSensed();
        });
        bodyObserver.observe(document.body, { subtree: true, childList: true, attributes: true });
        const headObserver = new MutationObserver(() => {
            onSensed();
        });
        headObserver.observe(document.head, { subtree: true, childList: true, attributes: true });
        return () => {
            bodyObserver.disconnect();
            headObserver.disconnect();
        };
    });
    return () => {
        print("Stopping");
        promisedCallback.then((stop) => {
            stop();
            print("Stopped");
        });
    };
}
exports.senseDocumentMutation = senseDocumentMutation;
function sensePageFacetFromDocument() {
    const element = document.querySelector(`meta[${Common_1.HTML_ATTR_CAPTURE_PAGE}]`);
    const propertyPrefix = Common_1.HTML_ATTR_PAGE_PROPERTY_PREFIX;
    const properties = Object.assign(Object.assign({}, Object.entries((element === null || element === void 0 ? void 0 : element.dataset) || {}).reduce((dict, [key, value]) => {
        if (key.startsWith(propertyPrefix) && value != null) {
            return Object.assign(Object.assign({}, dict), { 
                // remove adpProperty prefix and revert first
                [`${key.charAt(propertyPrefix.length).toLowerCase()}${key.substring(propertyPrefix.length + 1)}`]: value });
        }
        return dict;
    }, undefined)), { ADP_SDK_AUTO: "true" });
    return {
        category: element === null || element === void 0 ? void 0 : element.dataset.adpPageCategory,
        name: (element === null || element === void 0 ? void 0 : element.dataset.adpPageName) || document.title,
        properties,
    };
}
exports.sensePageFacetFromDocument = sensePageFacetFromDocument;
